export default __webpack_public_path__ + "static/icNqhmxr-71c679d1da3172c7fa40f78c10e8caf7.svg";